'use client';
import React from 'react';

const categories = [
  { emoji: '🥛', label: 'Dairy' },
  { emoji: '🍎', label: 'Fruits' },
  { emoji: '🥦', label: 'Veggies' },
  { emoji: '🍪', label: 'Snacks' },
  { emoji: '🧴', label: 'Personal Care' },
  { emoji: '🧹', label: 'Household' },
  { emoji: '🍳', label: 'Breakfast' },
  { emoji: '🥤', label: 'Beverages' },
  { emoji: '🍫', label: 'Chocolates' },
  { emoji: '🧊', label: 'Frozen' },
];

export default function CategoryBar() {
  return (
    <div className="bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-5">
        <div className="flex gap-3 md:gap-4 overflow-x-auto pb-1 scrollbar-hide">
          {categories?.map((cat) => (
            <button
              key={cat?.label}
              className="flex flex-col items-center gap-1.5 shrink-0 group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-gray-50 border border-gray-200 group-hover:border-[#0c831f] group-hover:bg-green-50 flex items-center justify-center text-2xl md:text-3xl transition-all duration-200 group-hover:shadow-md group-hover:scale-105">
                {cat?.emoji}
              </div>
              <span className="text-[10px] md:text-xs font-semibold text-gray-600 group-hover:text-[#0c831f] transition-colors whitespace-nowrap">
                {cat?.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
